import InputNumber, { InputNumberProps } from './InputNumber';
export { InputNumberProps };
export default InputNumber;
